import { render, staticRenderFns } from "./saas_shelf_edit.vue.vue?vue&type=template&id=35bc49bc&scoped=true"
import script from "./saas_shelf_edit.vue.vue?vue&type=script&lang=js"
export * from "./saas_shelf_edit.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc49bc",
  null
  
)

export default component.exports